import checkFeatureFlag from '@utils/checkFeatureFlag';
import { Header as HeaderV1 } from './Header-v1';
import { Header as HeaderV2 } from './Header-v2';

const Header =
  checkFeatureFlag('MODULES') === 'FLAG_VALID' ? HeaderV2 : HeaderV1;

export { Header };
